// Функция для преобразования 10000.0000 в 10 000.00
const formatNumber = (num) => {
    return num.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export {
    formatNumber
};